// extracted by mini-css-extract-plugin
export default {"navlink":"settings_navlink__Jms5i","active":"settings_active__53JM9"};